import {
  type ReactNode,
  createContext,
  useCallback,
  useEffect,
  useState,
} from 'react'

/** @deprecated */
export const SelectContext = /* #__PURE__ */ createContext<{
  setSelected: (item: any) => void
  clearAll: () => void
  selected: Set<any>
  focused: any
  setFocused: (item: any) => void
  multiple: boolean
}>({
  setSelected: () => {},
  clearAll: () => {},
  selected: new Set(),
  setFocused: () => {},
  focused: undefined,
  multiple: false,
})

/** @deprecated */
export function SelectContextProvider<T>({
  defaultValue = new Set<T>(),
  selected: controlledSelected,
  multiple = false,
  children,
  onChange,
  clearable,
}: {
  defaultValue: Set<T>
  selected?: Set<T>
  multiple?: boolean
  children: ReactNode
  onChange?: (values: Set<T>) => void
  clearable?: boolean
}) {
  const [selected, setSelected] = useState<Set<T>>(defaultValue)
  const [focused, setFocused] = useState<T | undefined>(undefined)

  const changeSelected = useCallback(
    (value: T) => {
      if (multiple) {
        setSelected((prev) => {
          const state = new Set(prev)

          if (state.has(value)) {
            state.delete(value)
          } else {
            state.add(value)
          }

          onChange?.(state)
          return state
        })
      } else {
        setSelected((prev) => {
          const state = new Set(prev)
          if (state.has(value)) {
            if (clearable) {
              state.delete(value)
            }
          } else {
            state.clear()
            state.add(value)
          }
          onChange?.(state)
          return state
        })
      }
    },
    [clearable, multiple, onChange],
  )

  const clearAll = useCallback(() => {
    const updatedState = new Set<T>()
    setSelected(updatedState)
    onChange?.(updatedState)
  }, [onChange])

  useEffect(() => {
    if (controlledSelected) {
      setSelected(controlledSelected)
    }
  }, [controlledSelected])

  return (
    <SelectContext.Provider
      value={{
        selected,
        clearAll,
        setSelected: changeSelected,
        focused,
        setFocused,
        multiple,
      }}
    >
      {children}
    </SelectContext.Provider>
  )
}
